sachaRun.$inject = ['$location', '$rootElement', '$rootScope'];
export function sachaRun($location, $rootElement, $rootScope) {

  // Set up tweaks to the UI when we are integrated in a 3rd party CRM:
  // - hiding the left side menu is handled with a CSS class
  // - disabling navigating away from task process page is handle with a root-scope variable
  //   (some js code automatically returns to the tasks list, for example when a task is archived)
  if (   $location.absUrl().indexOf('hide-nav=true') !== -1
      || $location.absUrl().indexOf('hide-nav%3Dtrue') !== -1) {
        
    $rootElement.addClass('hide-left-side-and-top-bar');
    $rootScope.$on('$stateChangeStart',
      function(event, toState, toParams, fromState, fromParams) {
        if ((fromState.name.indexOf('.process') != -1) &&
            !(toState.name.indexOf('.process') != -1)) {

          event.preventDefault();
          // transitionTo() promise will be rejected with a 'transition prevented' error
        }
      }
    );
    $rootScope.isEmbededInSacha = true;
  }

}